import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { oacento, uacento } from "../../utils/caracteresUTF8";
import { validationSchemaBancaria } from "../../utils/validationSchemaForm";
import Alert from "../../utils/alert";
import MaskedInput from "react-text-mask";
import { rutMask } from "../../utils/inputMask";
import { Collapse } from "react-collapse";
import { useNavigate } from "react-router-dom";
import { initialValuesFormFormaPago } from "../../utils/initialValues/formFormaPago";
import { HandleSubmitFormFormaPago } from "../../utils/handleSubmit/formFormaPago";
import { traerBancos } from "../../services/api/bancos";
import { Button, Spinner } from "react-bootstrap";

const FormFormaPago = (props) => {
  let history = useNavigate();

  const [alternativa, setAlternativa] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [instituciones, setinstituciones] = useState([]);
  const idPersona = localStorage.getItem("idPersona");
  const idCliente = Number.parseInt(localStorage.getItem("idCliente"));
  const informante = localStorage.getItem("informante");

  const handleSubmit = (values) => {
    HandleSubmitFormFormaPago({
      values: values,
      changeLoading: setIsLoading,
      informante: informante,
      alternativa: alternativa,
      idPersona: idPersona,
      idCliente: idCliente,
      history: history,
    });
  };

  useEffect(async () => {
    /***LLAMADA A SERVICIO BANCOS *****/

    const lista_bancos = await traerBancos();

    if (lista_bancos.status === 200 && lista_bancos.data.ok) {
      const array = [];

      lista_bancos.data.resultado.map((datos) => {
        array.push([datos.codBanco, datos.descripcion]);
      });

      setinstituciones(array);
    }
  }, [history.pathname]);

  return (
    <Formik
      initialValues={initialValuesFormFormaPago}
      validationSchema={validationSchemaBancaria}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form>
          <div id="accordion">
            <div className="custom-accordion">
              <div className="accordion-header" id="headingOne">
                {/* Radio Cuenta Bancaria  */}
                <Field name="radioButtonP">
                  {({ field }) => (
                    <div className="form-check">
                      <label
                        className="form-check-label mt-auto"
                        htmlFor="bancaria"
                      >
                        <input
                          {...field}
                          type="radio"
                          className="form-check-input"
                          name="radioButtonP"
                          autoComplete="off"
                          value="0"
                        />
                        <small className="bancaria">Cuenta Bancaria</small>
                      </label>
                    </div>
                  )}
                </Field>
              </div>

              {/* Form Cuenta Bancaria, only visible when radio cuenta bancaria P (primero) is selected  */}
              <Collapse isOpened={formik.values.radioButtonP === "0"}>
                <div className="accordion-body">
                  <Field name="rutP">
                    {({ field, meta }) => (
                      <div className="form-group input-wrapper mb-2">
                        <label htmlFor="" className="control-labelx">
                          Rut
                        </label>
                        <MaskedInput
                          {...field}
                          mask={rutMask}
                          type="text"
                          className={`form-control ${meta.touched
                            ? meta.error
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                            }`}
                          id="rut"
                          name="rutP"
                          aria-describedby="rutAyuda"
                          placeholder=""
                          autoComplete="off"
                        />
                        <small
                          id="rutAyuda"
                          className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                            }`}
                        >
                          {meta.touched && meta.error
                            ? meta.error
                            : "Ej. 12.345.678-9."}
                        </small>
                      </div>
                    )}
                  </Field>
                  <Field name="institucionP">
                    {({ field, meta }) => (
                      <div className="form-group input-wrapper mb-2">
                        <label htmlFor="rut" className="control-labelx">
                          {" "}
                          Instituci{oacento}n financiera
                        </label>
                        <select
                          {...field}
                          className="form-control"
                          id="institucion"
                          aria-describedby="institucionAyuda"
                          name="institucionP"
                        >
                          <option value="">Seleccionar</option>
                          {instituciones.sort().map((datos, index) => (
                            <option key={index} value={datos[0]}>
                              {datos[1]}
                            </option>
                          ))}
                        </select>
                        <small
                          id="institucionAyuda"
                          className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                            }`}
                        >
                          {meta.touched && meta.error ? meta.error : ""}
                        </small>
                      </div>
                    )}
                  </Field>
                  <Field name="tipoCuentaP">
                    {({ field, meta }) => (
                      <div className="form-group input-wrapper mb-2">
                        <label htmlFor="" className="control-labelx">Tipo de cuenta</label>
                        <select
                          {...field}
                          className="form-control"
                          id="tipoCuenta"
                          aria-describedby="tipoCuentaAyuda"
                          name="tipoCuentaP"
                        >
                          <option key={0} value="">
                            Seleccionar
                          </option>
                          <option key={1} value="2">
                            Cuenta Ahorro
                          </option>
                          <option key={2} value="3">
                            Cuenta Chequera electr{oacento}nica
                          </option>
                          <option key={3} value="1">
                            Cuenta Corriente
                          </option>
                          {formik.values.institucionP === "12" ? (
                            <option key={4} value="4">
                              CuentaRUT
                            </option>
                          ) : (
                            <option key={4} value="4">
                              Cuenta Vista
                            </option>
                          )}
                        </select>
                        <small
                          id="tipoCuentaAyuda"
                          className={`form-text ${meta.touched
                            ? meta.error
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                            }`}
                        >
                          {meta.touched && meta.error ? meta.error : ""}
                        </small>
                      </div>
                    )}
                  </Field>
                  <Field name="numeroCuentaP">
                    {({ field, meta }) => (
                      <div className="form-group input-wrapper mb-2">
                        <label htmlFor="" className="control-labelx">
                          N{uacento}mero de cuenta
                        </label>
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${meta.touched
                            ? meta.error
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                            }`}
                          id="numeroCuenta"
                          name="numeroCuentaP"
                          placeholder=""
                          autoComplete="off"
                          aria-describedby="numeroCuentaAyuda"
                        />
                        <small
                          id="numeroCuentaAyuda"
                          className={`form-text ${meta.touched && meta.error
                            ? "is-invalid"
                            : `El n${uacento}mero ingresado debe coincidir con el campo anterior.`
                            }`}
                        >
                          {meta.touched && meta.error ? meta.error : ""}
                        </small>
                      </div>
                    )}
                  </Field>
                  <Field name="numeroCuentaPConfirmar">
                    {({ field, meta }) => (
                      <div className="form-group input-wrapper mb-2">
                        <label htmlFor="" className="control-labelx">
                          Confirmar N{uacento}mero de cuenta
                        </label>
                        <input
                          {...field}
                          type="text"
                          className={`form-control ${meta.touched
                            ? meta.error
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                            }`}
                          id="numeroCuenta"
                          name="numeroCuentaPConfirmar"
                          placeholder=""
                          autoComplete="off"
                          aria-describedby="numeroCuentaAyuda"
                        />
                        <small
                          id="numeroCuentaAyuda"
                          className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                            }`}
                        >
                          {meta.touched && meta.error ? meta.error : ""}
                        </small>
                      </div>
                    )}
                  </Field>
                  <Alert
                    image="warning"
                    className="alert-secondary"
                    message="No está autorizado el depósito en cuentas bipersonales (con más de un titular), ni en cuentas digitales con procesos de apertura no presenciales, evite el rechazo de su solicitud."
                  />
                </div>
              </Collapse>
            </div>

            {/* Radio Vale Vista 1  */}
            <div className="custom-accordion">
              <div className="accordion-header" id="headingThree">
                <Field name="radioButtonP">
                  {({ field }) => (
                    <div className="form-check">
                      <label className="form-check-label mt-auto">
                        <input
                          {...field}
                          type="radio"
                          className="form-check-input"
                          name="radioButtonP"
                          autoComplete="off"
                          value="1"
                          disabled={formik.values.radioButtonS === "1"}
                          onChange={(e) => {
                            field.onChange(e);
                            if (e.target.value === "1") {
                              formik.setFieldValue("radioButtonS", "");
                            }
                          }}
                        />
                        <small className="vistaClass">Vale Vista</small>
                      </label>
                    </div>
                  )}
                </Field>
              </div>
              <Collapse isOpened={formik.values.radioButtonP === "1"}>
                <div className="accordion-body">
                  <Alert
                    image="warning"
                    className="alert-secondary"
                    message="El vale vista será emitido a nombre del mandatario en caso de estar facultado para el cobro. En caso contrario, será emitido a nombre del afiliado o beneficiario de pensión de sobrevivencia."
                  />
                </div>
              </Collapse>
            </div>
          </div>
          <br />

          <div className="row">
            <span className="textoSecundario">
              2- Ingresa la forma de pago alternativa {formik.values.radioButtonP === "0" && "(Obligatoria)"}
            </span>

            <div className="card-body">
              <p className="">
                Esta cuenta será utilizada solo en caso de que no podamos
                realizar el depósito en tu primera opción de pago.
              </p>

              <div className="">
                <div className="custom-accordion">
                  <div className="accordion-header" id="headingFour">
                    {/* Radio Cuenta Bancaria  */}
                    <Field name="radioButtonS">
                      {({ field }) => (
                        <div className="form-check">
                          <label
                            className="form-check-label mt-auto"
                            htmlFor="bancaria"
                          >
                            <input
                              {...field}
                              type="radio"
                              className="form-check-input"
                              name="radioButtonS"
                              autoComplete="off"
                              value="0"
                              disabled={formik.values.radioButtonP === "1"}
                            />
                            <small className="bancaria">Cuenta Bancaria</small>
                          </label>
                        </div>
                      )}
                    </Field>
                  </div>
                  {/* Form Cuenta Bancaria, only visible when radio cuenta bancaria S (segundo) is selected  */}
                  <Collapse isOpened={formik.values.radioButtonS === "0"}>
                    <div className="accordion-body">
                      <Field name="rutS">
                        {({ field, meta }) => (
                          <div className="form-group input-wrapper mb-2">
                            <label htmlFor="rut" className="control-labelx">
                              Rut
                            </label>
                            <MaskedInput
                              {...field}
                              mask={rutMask}
                              type="text"
                              className={`form-control ${meta.touched
                                ? meta.error
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                                }`}
                              id="rut"
                              name="rutS"
                              aria-describedby="rutAyuda"
                              placeholder=""
                              autoComplete="off"
                            />
                            <small
                              id="rutAyuda"
                              className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                                }`}
                            >
                              {meta.touched && meta.error
                                ? meta.error
                                : "Ej. 12.345.678-9."}
                            </small>
                          </div>
                        )}
                      </Field>
                      <Field name="institucionS">
                        {({ field, meta }) => (
                          <div className="form-group input-wrapper mb-2">
                            <label htmlFor="" className="control-labelx">
                              {" "}
                              Instituci{oacento}n financiera
                            </label>
                            <select
                              {...field}
                              className="form-control"
                              id="institucion"
                              aria-describedby="institucionAyuda"
                              name="institucionS"
                            >
                              <option value="">Seleccionar</option>
                              {instituciones.sort().map((datos, index) => (
                                <option key={index} value={datos[0]}>
                                  {datos[1]}
                                </option>
                              ))}
                            </select>
                            <small
                              id="institucionAyuda"
                              className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                                }`}
                            >
                              {meta.touched && meta.error ? meta.error : ""}
                            </small>
                          </div>
                        )}
                      </Field>
                      <Field name="tipoCuentaS">
                        {({ field, meta }) => (
                          <div className="form-group input-wrapper mb-2">
                            <label htmlFor="" className="control-labelx">
                              Tipo de cuenta
                            </label>
                            <select
                              {...field}
                              className="form-control"
                              id="tipoCuenta"
                              aria-describedby="tipoCuentaAyuda"
                              name="tipoCuentaS"
                            >
                              <option key={0} value="">
                                Seleccionar
                              </option>
                              <option key={1} value="2">
                                Cuenta Ahorro
                              </option>
                              <option key={2} value="3">
                                Cuenta Chequera electr{oacento}nica
                              </option>
                              <option key={3} value="1">
                                Cuenta Corriente
                              </option>
                              {formik.values.institucionS === "12" ? (
                                <option key={4} value="4">
                                  CuentaRUT
                                </option>
                              ) : (
                                <option key={4} value="4">
                                  Cuenta Vista
                                </option>
                              )}
                            </select>
                            <small
                              id="tipoCuentaAyuda"
                              className={`form-text ${meta.touched
                                ? meta.error
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                                }`}
                            >
                              {meta.touched && meta.error ? meta.error : ""}
                            </small>
                          </div>
                        )}
                      </Field>
                      <Field name="numeroCuentaS">
                        {({ field, meta }) => (
                          <div className="form-group input-wrapper mb-2">
                            <label htmlFor="" className="control-labelx">
                              N{uacento}mero de cuenta
                            </label>
                            <input
                              {...field}
                              type="text"
                              className={`form-control ${meta.touched
                                ? meta.error
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                                }`}
                              id="numeroCuenta"
                              name="numeroCuentaS"
                              placeholder=""
                              autoComplete="off"
                              aria-describedby="numeroCuentaAyuda"
                            />
                            <small
                              id="numeroCuentaAyuda"
                              className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                                }`}
                            >
                              {meta.touched && meta.error ? meta.error : ""}
                            </small>
                          </div>
                        )}
                      </Field>
                      <Field name="numeroCuentaSConfirmar">
                        {({ field, meta }) => (
                          <div className="form-group input-wrapper mb-2">
                            <label htmlFor="" className="control-labelx">
                              Confirmar n{uacento}mero de cuenta
                            </label>
                            <input
                              {...field}
                              type="text"
                              className={`form-control ${meta.touched
                                ? meta.error
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                                }`}
                              id="numeroCuenta"
                              name="numeroCuentaSConfirmar"
                              placeholder=""
                              autoComplete="off"
                              aria-describedby="numeroCuentaAyuda"
                            />
                            <small
                              id="numeroCuentaAyuda"
                              className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                                }`}
                            >
                              {meta.touched && meta.error ? meta.error : ""}
                            </small>
                          </div>
                        )}
                      </Field>
                      <Alert
                        image="warning"
                        className="alert-secondary"
                        message="No está autorizado el depósito en cuentas bipersonales (con más de un titular), ni en cuentas digitales con procesos de apertura no presenciales, evite el rechazo de su solicitud."
                      />
                    </div>
                  </Collapse>
                </div>

                {/* Radio Vale Vista 2  */}
                <div className="custom-accordion">
                  <div className="accordion-header" id="headingTwo">
                    <Field name="radioButtonS">
                      {({ field }) => (
                        <div className="form-check">
                          <label className="form-check-label mt-auto">
                            <input
                              {...field}
                              type="radio"
                              className="form-check-input"
                              name="radioButtonS"
                              autoComplete="off"
                              value="1"
                              disabled={formik.values.radioButtonP === "1"}
                            />
                            <small className="vistaClass">Vale Vista</small>
                          </label>
                        </div>
                      )}
                    </Field>
                  </div>
                  {/* Panel alert Vale Vista 2  */}
                  <Collapse isOpened={formik.values.radioButtonS === "1"}>
                    <div className="accordion-body">
                      <Alert
                        image="warning"
                        className="alert-secondary"
                        message="El vale vista será emitido a nombre del mandatario en caso de estar facultado para el cobro. En caso contrario, será emitido a nombre del afiliado o beneficiario de pensión de sobrevivencia."
                      />
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>

          <div className="justify-content-center d-flex mb-2">
            <Button
              variant="success"
              className="col-md-12"
              type="submit"
              disabled={!(formik.isValid && formik.dirty) || isLoading}
            >
              {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
            </Button>
          </div>
          <div className="justify-content-center d-flex blue-a mb-2">
            <Button variant="link" className="col-md-12"
              onClick={() => {
                history(-1);
              }}>
              Volver al paso anterior
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormFormaPago;
